<div class="col-sm-12 offset-md-1 col-md-10 mt-3">
  <div class="row toplogin">
    <div class="form-back h4 my-4">
      <a
        class="egd-theme"
        role="button"
        (click)="this.login_data.goBack(this.backUrl, this.router)"
        >&#8592; Back</a
      >
    </div>
    <div>
      <a
        href="javascript:void(0)"
        (click)="openLink('HOMPAGE_BASE_URL', '', '_self')"
      >
        <img
          [src]="this.logo_url"
          class="egd-navbar-logo"
          alt="egd-logo"
          style="float: right"
        />
      </a>
    </div>
  </div>

  <div class="form-heading-section mt-1">
    <h2>Login-Patient</h2>
    <p class="form-sub-heading">
      Just a step away from starting your consultation!
    </p>
    <p class="form-tagline">
      <small>Sign in with Email Address or Mobile Number</small>
    </p>
  </div>
  <div class="container ml-lg-5 pl-lg-5">
    <div class="row p-lg-2">
      <div
        class="btn-group togglebtngrp mb-4 col-lg-9 col-md-12 col-sm-12"
        role="group"
        aria-label="Login options"
      >
        <button
          type="button"
          class="btn btn-outline-primary left-btn"
          (click)="this.login_data.toggleLoginType(false)"
          [class.active]="!this.login_data.userid_data.is_email"
        >
          Phone
        </button>

        <button
          type="button"
          class="btn btn-outline-primary right-btn"
          (click)="this.login_data.toggleLoginType(true)"
          [class.active]="this.login_data.userid_data.is_email"
        >
          Email
        </button>
      </div>
    </div>

    <div class="form-div justify-content-center">
      <ng-container *ngIf="this.login_data.tabViewData.selected_tab == 0">
        <form
          #userIdForm="ngForm"
          autocomplete="off"
          (ngSubmit)="loginmain()"
          accept-charset="UTF-8"
          *ngIf="this.login_data.userid_data.toggle_Reset"
        >
          <div class="form-group row mb-0 pb-0">
            <div class="col-lg-9 col-md-12 col-sm-12 ml-1">
              <userid-input
                [userid_data]="this.login_data.userid_data"
              ></userid-input>
              <button
                type="button"
                [disabled]="
                  !this.login_data.userid_data.continueButtonCondition()
                "
                *ngIf="
                  this.login_data.show_otp_button &&
                  !this.login_data.otp_data.OTP_validate_api.is_password
                "
                class="btn btn-sm btn-primary mr-3 pt-0 mt-0 mb-3 getoptpbtn"
                style="float: right"
                (click)="getOTP()"
              >
                Click here to Get OTP
              </button>
            </div>
          </div>
          <div
            class="form-group row"
            *ngIf="
              !this.login_data.otp_data.OTP_validate_api.is_password &&
              this.login_data.show_otp_input
            "
          >
            <otp-input
              class="col-lg-12 col-md-12 col-sm-12 ml-1"
              [isPrimeNg]="false"
              [otp_data]="this.login_data.otp_data"
              (otp_resend)="otp_resend()"
              required
            >
            </otp-input>
          </div>

          <ng-container
            *ngIf="this.login_data.otp_data.OTP_validate_api.is_password"
          >
            <div class="form-group row">
              <label class="col-sm-12 ml-1" for="password">Password*</label>
              <div class="input-div col-md-12 col-lg-9">
                <div class="input-group">
                  <input
                    id="password"
                    name="password"
                    [type]="
                      this.login_data.password_input.isPassword
                        ? 'password'
                        : 'text'
                    "
                    class="form-control input-of-input-icon"
                    aria-describedby="password"
                    placeholder="********"
                    [(ngModel)]="this.login_data.login_modal.password"
                    #password="ngModel"
                    minlength="8"
                    [class.form-input-error]="
                      password.invalid &&
                      (password.dirty || password.touched) &&
                      password.errors.required
                    "
                    [class.form-input-success]="
                      !password.invalid &&
                      (password.dirty || password.touched) &&
                      !(password.errors?.required || password.errors?.minlength)
                    "
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text icon-of-input-icon">
                      <i
                        toggle="#password-field"
                        role="button"
                        class="text-dark fa fa-fw"
                        [class.fa-eye]="
                          this.login_data.password_input.isPassword
                        "
                        [class.fa-eye-slash]="
                          !this.login_data.password_input.isPassword
                        "
                        [class.form-input-error]="
                          password.invalid &&
                          (password.dirty || password.touched) &&
                          password.errors.required
                        "
                        [class.form-input-success]="
                          !password.invalid &&
                          (password.dirty || password.touched) &&
                          !(
                            password.errors?.required ||
                            password.errors?.minlength
                          )
                        "
                        (click)="this.login_data.password_input.toggleType()"
                      >
                      </i>
                    </span>
                  </div>
                </div>
              </div>

              <div
                *ngIf="password.invalid && (password.dirty || password.touched)"
                class="col-sm-12"
              >
                <div
                  *ngIf="password.errors.required"
                  class="col-sm-12 alert alert-danger m-2"
                  role="alert"
                >
                  Password is required.
                </div>
                <div
                  *ngIf="password.errors.minlength"
                  class="col-sm-12 alert alert-danger m-2"
                  role="alert"
                >
                  Minimum length should be of 8 characters.
                </div>
              </div>
            </div>
          </ng-container>

          <div class="form-group row">
            <div class="col-lg-9 col-sm-12">
              <div class="form-submit-button ml-lg-2">
                <button
                  type="submit"
                  class="btn btn-primary font-weight-bold text-white p-2"
                  [disabled]="
                    !userIdForm.valid ||
                    isPosting() ||
                    !this.login_data.userid_data.continueButtonCondition() ||
                    this.login_data.disabled()
                  "
                >
                  Login
                </button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="form-group form-check ml-md-5 ml-4">
              <input
                type="checkbox"
                [(ngModel)]="
                  this.login_data.otp_data.OTP_validate_api.is_password
                "
                (ngModelChange)="onOTPCheckboxChange()"
                class="form-check-input register-checkbox-fix"
                id="terms"
                name="terms"
              />
              <label class="form-check-label" for="customCheck1">
                Login with Password instead of OTP?
              </label>
            </div>
          </div>
        </form>
      </ng-container>

      <div class="mt-3 mx-2">
        <div class="row">
          <app-loading
            class="col-12 text-center"
            *ngIf="isPosting()"
            type="SMALL_LOADER"
          >
          </app-loading>
        </div>

        <app-error-messages
          *ngIf="!this.login_data.login_api_result.PromiseResult.success"
          [api_result]="this.login_data.login_api_result"
        >
        </app-error-messages>

        <app-error-messages
          [api_result]="this.login_data.otp_data.otp_api_result"
        >
        </app-error-messages>

        <div
          *ngIf="
            this.login_data.login_api_result.PromiseResult.success == false &&
            this.login_data.login_api_result.PromiseResult.error?.code ==
              'LOGIN_02'
          "
          class="alert alert-danger"
        >
          Account is not verified. Click
          <br />
          <a class="text-to-link" [routerLink]="['/', this.slug, 'user', 'verify-userid', 'patient']"
            >here</a
          >
          to verify your account.
        </div>
        <div
          *ngIf="
            this.login_data.login_api_result.PromiseResult.success == false &&
            this.login_data.login_api_result.PromiseResult.error?.code ==
              'Locked'
          "
          class="alert alert-danger"
        >
          Your account has been locked, please reset your password.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-7">
      <p>
        Not yet registered ?
        <a [routerLink]="['/', this.slug, 'user', 'register', 'patient']" style="font-weight: bold"
          >Create an account</a
        >
      </p>
    </div>
    <div class="col-sm-5">
      <p>
        <a
        [routerLink]="['/', this.slug, 'user', 'forget-password', 'patient']"
          class="mt-2"
          style="font-weight: bold"
        >
          Forgot password?
        </a>
        <br />
        <!-- <a routerLink="/user/forget-email/patient" class="my-1">
                    Forgot User ID?
                </a> -->
      </p>
    </div>
  </div>

  <div class="footer-copyright-section mt-2">
    <p class="footer-copyright-text text-center">
      2025 Copyright <span>&#169;</span> All rights reserved by
      <a
        href="javascript:void(0)"
        (click)="openLink('HOMPAGE_BASE_URL', '', '_self')"
        style="color: #1850a0"
        >eGlobalDoctors</a
      >
    </p>
  </div>
</div>
